import { Controller, useFormContext } from 'react-hook-form'

import {
  PickerFormControl,
  PickerFormControlSpaceIdProps,
} from '../EntityPicker/PickerFormControl.js'

import { FormFieldProps } from './typings.js'

export function FormSpaceIdPicker({
  name,
  validation,
  /**
   * Will override default Form onChange behavior. The original onChange will be passed as the second argument
   */
  onChange: overrideOnChange,
  ...rest
}: Omit<FormFieldProps<PickerFormControlSpaceIdProps>, 'value' | 'onChange'> & {
  onChange?: (
    spaceIds: string[],
    originalOnChange?: (spaceIds: string[]) => void,
  ) => void
}) {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <PickerFormControl.SpaceIdPicker
          {...rest}
          name={name}
          invalid={!!error?.message}
          error={error?.message}
          value={value}
          onChange={value => {
            if (overrideOnChange) {
              overrideOnChange(value, onChange)
            } else {
              onChange(value)
            }
          }}
        />
      )}
    />
  )
}
